/* Phase 71 — Single source of truth for CarHive's public company data.
 *
 * Used by:
 *  • /pages/Legal.jsx — Impressum, Datenschutz, AGB, Kontakt
 *  • /components/Footer.jsx — Trust block
 *  • /lib/schema.js — Organization JSON-LD
 */

export const COMPANY = {
  // Public trade name / marketplace brand.
  name: "CarHive",

  // Legally responsible operator (natural person — Einzelfirma /
  // Einzelunternehmen). Rendered in Impressum, Datenschutz "Verantwortliche
  // Stelle" and AGB "Anbieter/Vertragspartner".
  operator: {
    fullName: "Arnaldo Flávio Gonçalves Tafolli",
    street: "Zelglistrasse 11",
    zip: "8953",
    city: "Dietikon",
    country: "Schweiz",
  },

  // Public-facing emails (routed to the appropriate inbox).
  emails: {
    general: "info@carhive.ch",
    support: "support@carhive.ch",
    privacy: "datenschutz@carhive.ch",
    legal:   "legal@carhive.ch",
  },

  // Operational SLAs.
  responseTimeHours: 24, // weekdays

  // Country / website.
  country: "Schweiz",
  website: "https://carhive.ch",

  // ── Feature flags ────────────────────────────────────────────────
  hasAddress: true,                 // operator address now available
  hasPhone: false,
  hasWhatsapp: false,
  hasCommercialRegister: false,     // UID pending — no HR-Eintrag yet
};

/** Locale-native response-time copy used in Footer + Impressum trust block. */
export const RESPONSE_TIME_COPY = {
  de: `Antwort innerhalb von ${COMPANY.responseTimeHours} h (Werktage)`,
  fr: `Réponse sous ${COMPANY.responseTimeHours} h (jours ouvrés)`,
  it: `Risposta entro ${COMPANY.responseTimeHours} h (giorni feriali)`,
  en: `Reply within ${COMPANY.responseTimeHours} h (business days)`,
};

/** Multi-line legal operator block used in Impressum, Datenschutz and AGB.
 *  Returns e.g.:
 *    Arnaldo Flávio Gonçalves Tafolli
 *    CarHive
 *    Zelglistrasse 11
 *    8953 Dietikon
 *    Schweiz
 */
export function operatorLines() {
  const o = COMPANY.operator;
  return [o.fullName, COMPANY.name, o.street, `${o.zip} ${o.city}`, o.country];
}
